import React from "react";
import { getDrupalImageUrl } from "../../api/about/aboutapi";

interface HeroProps {
  data: any;
}
const AboutSectionsn: React.FC<HeroProps> = ({ data}) => {

    const node = data.data;
  
     /** Collect included images */
    const included = data?.included || [];
  
     // 📌 Featured image URL
    const featuredId = node?.relationships?.field_featured_image?.data?.id;
    const featuredUrl = getDrupalImageUrl(featuredId, included);
  
     // 📌 Gallery Images
     const galleryIds = node?.relationships?.field_gallery_images?.data || [];
     const galleryUrls = galleryIds
       .map((g: any) => getDrupalImageUrl(g.id, included))
       .filter(Boolean);
   
     //console.log(galleryUrls);
  return (
    <section id="about" className="about pt-3 section">
      <div className="container">
        <div className="row gx-2 align-items-xl-center text-center gy-md-5">
          <div className="col-xl-12 content ">
            <label className="label-title">{node?.attributes?.field_sub_title || ""}</label>
          </div>

          <div className="col-xl-12">
            <div className="row gy-4 icon-boxes">
              <div className="offset-md-1 col-md-10">
                <p className="mb-4">{node?.attributes?.field_description || ""}</p>
                {featuredUrl && (
                  <img src={featuredUrl}  loading="lazy" height="120"className="mb-4" />
                )}
               

                <p  dangerouslySetInnerHTML={{  __html: node?.attributes?.field_content?.value || "" }}  />

                <p>{ node?.attributes?.field_sub_description || ""}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSectionsn;